import React from "react";
import { Box, IconButton, TextField, Button, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { DynamicListFieldProps } from './DynamicListField.types';

const DynamicListField = ({ value, onChange, itemFields, label }: DynamicListFieldProps) => {
  const handleItemChange = (index: number, field: string, fieldValue: any) => {
    const newList = [...value];
    newList[index] = { ...newList[index], [field]: fieldValue };
    onChange(newList);
  };

  const handleAdd = () => {
    onChange([...value, Object.fromEntries(itemFields.map((f) => [f.name, '']))]);
  };

  const handleDelete = (index: number) => {
    const newList = value.filter((_, i) => i !== index);
    onChange(newList);
  };

  return (
    <Box>
      {label && <Box mb={1}>{label}</Box>}
      {value.map((item, idx) => (
        <Box
          key={idx}
          display="flex"
          alignItems="center"
          gap={2}
          mb={1}
          sx={{ background: '#f7f7f7', p: 1, borderRadius: 1 }}
        >
          {itemFields.map((f) =>
            f.type === 'select' ? (
              <TextField
                key={f.name}
                select
                label={f.label}
                size="small"
                value={item[f.name] ?? ''}
                onChange={(e) => handleItemChange(idx, f.name, e.target.value)}
                sx={f.sx}
              >
                {(typeof f.getOptions === 'function' ? f.getOptions(item) : f.options || []).map(
                  (opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  )
                )}
              </TextField>
            ) : (
              <TextField
                key={f.name}
                label={f.label}
                size="small"
                type={f.type ?? 'text'}
                value={item[f.name] ?? ''}
                onChange={(e) => handleItemChange(idx, f.name, e.target.value)}
                sx={f.sx}
              />
            )
          )}
          <IconButton onClick={() => handleDelete(idx)} color="error">
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <Button variant="outlined" startIcon={<AddIcon />} onClick={handleAdd} sx={{ mt: 1 }}>
        Dodaj wartość
      </Button>
    </Box>
  );
};

export default DynamicListField;
